<ng-container *ngIf="consolelog$ | async as consoleLogs">
  <ion-header>
    <ion-toolbar>
      <ion-title>Console log <ion-icon name="copy-outline" (click)="copy(consoleLogs)"></ion-icon></ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">Close <ion-icon name="close-outline"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-list>
      <ion-item *ngFor="let consolelog of consoleLogs" [color]="consolelog.priority">
        <ion-label>
          <h2>{{consolelog.title}}</h2>
          <h3>{{consolelog.message}}</h3>
          <p>{{consolelog.origin}}</p>
          <p><small>{{consolelog.timestamp | date : "dd.MM.y HH:mm:ss"}}</small></p>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-button (click)="clear()" size="default" class="ion-margin-top">
          <ion-icon slot="icon-only" name="trash"></ion-icon>
        </ion-button>
        <!-- <ion-button (click)="save()">
          <ion-icon slot="icon-only" name="trash"></ion-icon>
        </ion-button> -->
      </ion-item>
    </ion-list>

  </ion-content>

</ng-container>